export default {
    isFilterData(state, payload) {
        state.isCallFilter = !state.isCallFilter;
        state.queryFilter = payload.queryFilter;
        state.filterContentSave = payload.filterContentSave;
    },
    resetFilter(state, payload) {
        state.filterContentSave = payload.data;
    }
};
